/*** IMPORTS FROM imports-loader ***/
var global = window;

'use strict';

module.exports = {
  silentJSONParsing: true,
  forcedJSONParsing: true,
  clarifyTimeoutError: false
};

